import { render, staticRenderFns } from "./RegistroProv.vue?vue&type=template&id=b4bd23f0&scoped=true&"
import script from "./RegistroProv.vue?vue&type=script&lang=js&"
export * from "./RegistroProv.vue?vue&type=script&lang=js&"
import style0 from "./RegistroProv.vue?vue&type=style&index=0&id=b4bd23f0&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4bd23f0",
  null
  
)

export default component.exports